let modals = require( './modals' );

let update_share_details_toggle = function( $ ) {

	let $form,
		$popup,
		should_show_popup = true;

	let _init = function() {
		$form  = $( '#staff-share-details-form form' );
		$popup = $( '#practice-update-share-details' );

		if ( $form.length > 0 && $popup.length > 0 ) {
			_setup_form();
			_setup_popup();
		}
	};

	let _setup_form = function() {
		let $checkbox = $form.find( '#toggle-share-details' );

		$checkbox.on( 'change', ( e ) => {
			let val = $checkbox.is( ':checked' );

			if ( val ) {
				_update_popup( 'turn-on' );
			} else {
				_update_popup( 'turn-off' )
			}

			if ( should_show_popup ) {
				_show_popup();
			}
		} );

		$form.on( 'submit', ( e ) => {
			e.preventDefault();

			$form.loading();

			let val = $checkbox.is( ':checked' );

			if ( val ) {
				_update_share_details( true );
			} else {
				_update_share_details( false );
			}
		} )
	};

	let _setup_popup = function() {
		let $cancel_link = $popup.find( '.cancel-change' ),
			$change_link = $popup.find( '#change-shared-details' );

		$cancel_link.on( 'click', ( e ) => {
			e.preventDefault();

			should_show_popup = false;

			let $checkbox = $form.find( '#toggle-share-details' );

			if ( $checkbox.is( ':checked' ) ) {
				$checkbox.prop( 'checked', false );
			} else {
				$checkbox.prop( 'checked', true );
			}

			should_show_popup = true;
		} );

		$change_link.on( 'click', ( e ) => {
			e.preventDefault();

			$form.submit();
		} )
	};

	let _update_popup = function( type ) {
		type = 'turn-on' === type ? 'turn-on' : 'turn-off';

		let other_type = type === 'turn-on' ? 'turn-off' : 'turn-on';

		$popup.addClass( type );
		$popup.removeClass( other_type );
	};

	let _show_popup = function() {
		modals.open_modal( $popup );
	};

	let _update_share_details = function( value ) {
		let data = {
			nonce: ScriptData.crate_update_staff_shared_details_nonce,
			action: 'crate_update_staff_shared_details',
			value: value
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			console.log( response );

			if ( ! response.success ) {
				window.location.reload(); // Error so refresh the page
			}

			$form.loaded();
		} );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = update_share_details_toggle;